import React from 'react'
import './whitepaperoverview.scss'
const Whitepaperoverview = () => {
    return (
        <>
            <section className='overviewwhitepaperprnt'>

                <div className="custom-container">
                    <div className="storyprnt">

                        <div className="aboutusmission">

                            <div className="aboutusmissioncnt">
                                <div className="aboutusmissioncntcntchld">

                                    <p><a style={{pointerEvents: "none"}}>//tomi Storage API</a></p>
                                    <h1>Build on Storage with Our API</h1>
                                </div>
                                <p>Seamlessly integrate decentralized, censorship-resistant storage into your applications with our powerful API.</p>
                            </div>
                            <a href="https://tomi-storage-api.gitbook.io/tomi-storage-api-docs" target="_blank">
                                <button className='primerybtn'>
                                Documentation
                                </button>
                            </a>
                        </div>
                        <div className="rightimgprnt">
                            <img className='img-fluid imgwhitepaperoverview' src="\assets\Storageimages\getapiimgright.png" alt="" />
                        </div>


                    </div>
                </div>
            </section>
        </>
    )
}

export default Whitepaperoverview